import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localeEsExtra from '@angular/common/locales/extra/es';
import localeFrExtra from '@angular/common/locales/extra/fr';
import localeRuExtra from '@angular/common/locales/extra/ru';
import localeFr from '@angular/common/locales/fr';
import localeRu from '@angular/common/locales/ru';
import { APP_INITIALIZER, ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { DateFnsAdapter } from '@angular/material-date-fns-adapter';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router } from '@angular/router';
import { ApiGenModule } from '@api-gen/api-gen.module';
import { ApiRoamingModule } from '@api-roaming/api-roaming.module';
import { AuthModule } from '@auth/auth.module';
import { AppComponent } from '@core/containers/app/app.component';
import { CoreModule } from '@core/core.module';
import { LocaleService } from '@core/localization/locale.service';
import { defaultLocalizationConfig, LOCALIZATION_CONFIG } from '@core/localization/localization.config';
import { InitModule } from '@root/init/init.module';
import * as Sentry from '@sentry/angular';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha-2';
import { AppRoutingModule } from './app-routing.module';


@NgModule({
    imports: [
        BrowserAnimationsModule,
        CoreModule,
        AuthModule,
        AppRoutingModule,
        InitModule,
        RecaptchaV3Module,
        ApiGenModule,
        ApiRoamingModule,
    ],
    providers: [
        DateFnsAdapter,
        [
            { provide: LOCALIZATION_CONFIG, useValue: defaultLocalizationConfig },
            { provide: LOCALE_ID, useValue: LocaleService.getLocaleLang() },
        ],
        [
            {
                provide: RECAPTCHA_V3_SITE_KEY,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                useValue: (window as any).appSettings.APP_SETTINGS_RECAPTCHA_KEY,
            },
        ],
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ...((window as any).appSettings.APP_SETTINGS_SENTRY_DNS_URL
            ? [
                {
                    provide: ErrorHandler,
                    useValue: Sentry.createErrorHandler({
                        showDialog: false,
                    }),
                },
                {
                    provide: Sentry.TraceService,
                    deps: [Router],
                },
                {
                    provide: APP_INITIALIZER,
                    useFactory: () => {
                    },
                    deps: [Sentry.TraceService],
                    multi: true,
                },
            ]
            : []),
    ],
    bootstrap: [AppComponent],
})
export class AppModule {
}

registerLocaleData(localeRu, 'ru', localeRuExtra);
registerLocaleData(localeEs, 'es', localeEsExtra);
registerLocaleData(localeFr, 'fr', localeFrExtra);
